import { flushStorage } from './package-storage';
import { setSessionId } from './session-id';
export const flushFullStorage = () => {
  if (document.visibilityState === 'hidden') {
    void setSessionId().then(() => {
      flushStorage(true);
    });
  }
};